
/* re-sync 2026-06-14: nudge GitHub→theme sync to re-pull this asset (whole-card link fix). */

/* Hard guard for the homepage rail: remove legacy panels by their stable IDs
   before the rail can select them. This is intentionally independent of the
   card-copy/classes because the homepage is stored as one custom-Liquid blob. */
(function(){
  function pruneById(){
    var isUK = window.location.hostname.indexOf('sameskies.co.uk') !== -1 || document.documentElement.lang === 'en-GB';
    (isUK ? [] : ['ss-pfp-6']).forEach(function(id){
      var panel = document.getElementById(id);
      if (panel) { panel.remove(); }
    });
    var tabs = document.querySelectorAll('.ss-pf__tab');
    (isUK ? [] : [6]).forEach(function(i){ if (tabs[i]) tabs[i].remove(); });
    var panels = document.querySelectorAll('.ss-pf__panel');
    if (panels.length && !document.querySelector('.ss-pf__panel.ss-pf-active')) panels[0].classList.add('ss-pf-active');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pruneById);
  else pruneById();
  setTimeout(pruneById, 800);
})();

/* ─── CURATED CATALOGUE SYNC (2026-09-09) ───
   The homepage rail is stored as custom Liquid in index.json, separately from
   the collection template. Keep its legacy panels out of the live catalogue
   while preserving the underlying products for the Gift Builder. British
   Treats is a UK-market-only panel. */
(function(){
  function pruneLegacyPanels(){
    var section = document.querySelector('.ss-pf');
    if (!section) return;
    var hide = []; // The former New Home slot is now Cosy Night In.
    var isUK = document.documentElement.lang === 'en-GB' ||
      window.location.hostname.indexOf('sameskies.co.uk') !== -1 ||
      document.body.classList.contains('market-united-kingdom');
    if (!isUK) hide.push(6); // UK Treats
    hide.forEach(function(i){
      var tab = section.querySelector('.ss-pf__tab:nth-child(' + (i + 1) + ')');
      var panel = section.querySelector('#ss-pfp-' + i);
      if (tab) tab.style.display = 'none';
      if (panel) panel.style.display = 'none';
    });
    var active = section.querySelector('.ss-pf__panel.ss-pf-active');
    if (active && hide.indexOf(Number(active.id.replace('ss-pfp-', ''))) !== -1) {
      active.classList.remove('ss-pf-active');
      var firstVisible = section.querySelector('.ss-pf__panel:not([style*="display: none"])');
      if (firstVisible) firstVisible.classList.add('ss-pf-active');
    }
    var viewAll = section.querySelector('.ss-pf__viewall a');
    if (viewAll) viewAll.textContent = 'View all 5 boxes →';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pruneLegacyPanels);
  else pruneLegacyPanels();
})();

/* ─── COSY NIGHT IN HOMEPAGE CARD (2026-09-09) ─────────────────────────────
   The original homepage rail is a legacy custom-Liquid blob. Reuse its
   retired New Home slot with the verified live Cosy product data so the card,
   drawer, price and contents stay truthful without duplicating a giant blob. */
(function(){
  function installCosyCard(){
    // 2026-09-11: retired. Cosy Night In is a cut box and the rail is now the
    // six-box lineup rendered straight from templates/index.json with live prices.
    return;
    var panel = document.getElementById('ss-pfp-4');
    var tab = document.querySelectorAll('#ss-pf-tabs .ss-pf__tab')[4];
    if (!panel) return;
    panel.dataset.ssCosyInstalled = 'true';
    if (tab) tab.textContent = 'Cosy Night In';

    var productUrl = '/products/gift-box-cosy-night-in';
    var photo = panel.querySelector('.ss-pf__photo');
    var cosyPhoto = window.ssHomeBoxImageUrls && window.ssHomeBoxImageUrls.cosy;
    if (photo) photo.style.backgroundImage = cosyPhoto
      ? 'url("' + cosyPhoto + '")'
      : "url('https://cdn.shopify.com/s/files/1/0714/6641/8336/files/gb-dusk.jpg?v=1783242346&width=800')";
    var copy = panel.querySelector('.ss-pf__content');
    if (copy) {
      var name = copy.querySelector('.ss-pf__cname'); if (name) name.textContent = 'Cosy Night In';
      var desc = copy.querySelector('.ss-pf__cdesc'); if (desc) desc.textContent = 'Permission to slow down. A candle, a bath soak, a chocolate bar, and full permission to do absolutely nothing.';
      var tags = copy.querySelector('.ss-pf__itags');
      if (tags) tags.innerHTML = '<span class="ss-pf__itag">Candle</span><span class="ss-pf__itag">Wellness Tea Samples</span><span class="ss-pf__itag">Bath Soak Test Tube</span><span class="ss-pf__itag">Calendula Bath Bomb</span><span class="ss-pf__itag">Love Cocoa Chocolate Bar</span><span class="ss-pf__itag">Raspberry White Chocolate Popcorn</span><span class="ss-pf__itag">Mediheal Sheet Face Mask</span>';
      var count = copy.querySelector('.ss-pf__inc-btn-count'); if (count) count.textContent = '7 ITEMS';
      var price = copy.querySelector('.ss-pf__price'); if (price) price.innerHTML = '<span class="ss-pf__price-from">From</span>$119';
    }
    panel.querySelectorAll('a.ss-pf__btn, a.ss-pf__inc-cta').forEach(function(link){ link.href = productUrl; });
    var title = panel.querySelector('.ss-pf__inc-title'); if (title) title.innerHTML = 'Everything in the <em>Cosy Night In</em> box';
    var popupPrice = panel.querySelector('.ss-pf__inc-price'); if (popupPrice) popupPrice.textContent = '$119';
    var assets = [
      ['candle-vessel-brown-glass-sameskies.jpg','Premium Soy Wax Candle'],
      ['wellness-tea-samples.jpg','Wellness Tea Samples'],
      ['bath-soak-test-tube.jpg','Bath Soak Test Tube'],
      ['calendula-bath-bomb.jpg','Calendula Bath Bomb'],
      ['love-cocoa-chocolate-bar-90g.jpg','Love Cocoa Chocolate Bar'],
      ['raspberry-white-chocolate-popcorn.jpg','Raspberry White Chocolate Popcorn'],
      ['mediheal-face-mask.jpg','Mediheal Sheet Face Mask']
    ];
    panel.querySelectorAll('.ss-pf__inc-item img').forEach(function(img, index){
      if (!assets[index]) return;
      img.src = 'https://cdn.shopify.com/s/files/1/0714/6641/8336/files/' + assets[index][0] + '?width=400';
      img.alt = assets[index][1];
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installCosyCard);
  else installCosyCard();
  setTimeout(installCosyCard, 300);
  setTimeout(installCosyCard, 1200);
  setTimeout(installCosyCard, 2500);
})();

/* ─── HOMEPAGE BOX PHOTOGRAPHY (2026-09-10) ────────────────────────────────
   The rail lives in a legacy custom-Liquid blob. The image URLs come from the
   layout so Shopify resolves versioned theme assets correctly in this JS file. */
(function(){
  function applyHomepagePhotography(){
    var urls = window.ssHomeBoxImageUrls;
    if (!urls) return;
    // 2026-09-11 panel order: Thinking of You, For Her, Traveller, For Him, Birthday, New Beginning.
    // Thinking of You reuses the comfort-box photo; New Beginning keeps its Liquid asset (no photo yet).
    [
      ['ss-pfp-0', urls.hug],
      ['ss-pfp-1', urls.forHer],
      ['ss-pfp-2', urls.traveller],
      ['ss-pfp-3', urls.forHim],
      ['ss-pfp-4', urls.newBeginning]
    ].forEach(function(entry){
      var panel = document.getElementById(entry[0]);
      var photo = panel && panel.querySelector('.ss-pf__photo');
      // Photos server-rendered in index.json (2026-09-29): nothing to swap, and
      // a background here would only add a layer under the <img>.
      if (photo && photo.querySelector('.ss-pf__photo-img')) return;
      if (photo && entry[1]) photo.style.backgroundImage = 'url("' + entry[1] + '")';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyHomepagePhotography);
  else applyHomepagePhotography();
  setTimeout(applyHomepagePhotography, 300);
  setTimeout(applyHomepagePhotography, 1200);
})();

/* ─── MOBILE WHITE-OUT HARD-FIX (2026-06-20) ───
   Render each card photo as a REAL <img> instead of leaning on the CSS
   background-image. On Android Chrome a background-image painted on a
   rounded, overflow:hidden box inside a touch scroller intermittently
   blanks to white when that layer is composited on press-and-hold — the
   reported "select the picture, hold a second, the whole card goes white"
   bug. Earlier fixes (dropping contain:paint, gating hover transforms,
   releasing the rail's GPU layer on touch) removed the compositor triggers
   we could find, but the background-image paint path is the root. A real
   <img> goes through the normal image decode/paint pipeline and is immune.
   The inline background-image stays as a no-JS fallback; the <img> sits at
   z-index 0, beneath the No./badge/testimonial overlays. Idempotent. */
(function(){
  function urlFrom(bg){
    if (!bg || bg === 'none') return '';
    var m = bg.match(/url\((['"]?)(.*?)\1\)/);
    return m ? m[2] : '';
  }
  function swapPhotos(){
    var photos = document.querySelectorAll('.ss-pf__photo');
    for (var i = 0; i < photos.length; i++){
      var photo = photos[i];
      if (photo.dataset.imgFixed === '1') continue;
      var url = urlFrom(photo.style.backgroundImage) ||
                urlFrom(getComputedStyle(photo).backgroundImage);
      if (!url) continue;
      photo.dataset.imgFixed = '1';
      var img = document.createElement('img');
      img.className = 'ss-pf__photo-img';
      img.src = url;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.loading = 'eager';
      img.decoding = 'async';
      img.draggable = false;
      photo.insertBefore(img, photo.firstChild);
      // Once the real <img> has painted, drop the CSS background-image so there
      // is NO background layer left that can blank to white on Android. The
      // <img> reuses the already-fetched URL, so clearing on load avoids any
      // flash. Closure over `photo` via an IIFE so the loop var is captured.
      (function(ph, im){
        function dropBg(){ ph.style.backgroundImage = 'none'; }
        if (im.complete && im.naturalWidth > 0) dropBg();
        else im.addEventListener('load', dropBg);
      })(photo, img);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', swapPhotos);
  else swapPhotos();
})();

/* ─── DESKTOP BOX SHOT + HOVER SPREAD (2026-09-29) ───
   Desktop with a real pointer: the card shows the closed-up box shot, and the
   spread underneath fades in on hover/focus (CSS). The box <img> is stacked
   straight after the spread <img> that swapPhotos() creates, so it waits for
   that img to exist. Touch devices never get the layer - they keep the spread. */
(function(){
  var DESKTOP = '(min-width: 821px) and (hover: hover) and (pointer: fine)';
  function addBoxShots(){
    var urls = window.ssHomeBoxShotUrls;
    if (!urls || !window.matchMedia || !window.matchMedia(DESKTOP).matches) return;
    [
      ['ss-pfp-0', urls.hug],
      ['ss-pfp-1', urls.forHer],
      ['ss-pfp-2', urls.traveller],
      ['ss-pfp-3', urls.forHim],
      ['ss-pfp-4', urls.newBeginning]
    ].forEach(function(entry){
      var panel = document.getElementById(entry[0]);
      var photo = panel && panel.querySelector('.ss-pf__photo');
      var spread = photo && photo.querySelector('.ss-pf__photo-img:not(.ss-pf__photo-box)');
      if (!spread || !entry[1] || photo.querySelector('.ss-pf__photo-box')) return;
      var img = document.createElement('img');
      img.className = 'ss-pf__photo-img ss-pf__photo-box';
      img.src = entry[1];
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.loading = 'eager';
      img.decoding = 'async';
      img.draggable = false;
      spread.insertAdjacentElement('afterend', img);
      photo.classList.add('has-box-shot');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addBoxShots);
  else addBoxShots();
  setTimeout(addBoxShots, 300);
  setTimeout(addBoxShots, 1200);
  setTimeout(addBoxShots, 2500);
})();

/* ─── POLAROID LAYOUT TOGGLE ───
   Adds .layout-polaroid to the .ss-pf section. CSS does the rest.
   Also makes each .ss-pf__card whole-clickable (delegates to the
   internal "Send this →" anchor href). To disable polaroid layout
   without redeploying: in DevTools, run
     document.querySelector('.ss-pf').classList.remove('layout-polaroid')
*/
(function(){
  function applyPolaroid(){
    var section = document.querySelector('.ss-pf');
    if (!section) return;
    section.classList.add('layout-polaroid');
    document.body.classList.add('ss-polaroid-active');

    // Drawer slide animation. Drives transform via inline style with an
    // explicit reflow gate so the CSS transition reliably picks up the
    // change. (Standard "from→reflow→to" pattern that survives Shopify's
    // theme stylesheet interactions.)
    if (!window._ssDrawerAnim) {
      window._ssDrawerAnim = true;
      var EASE = 'cubic-bezier(0.32, 0.72, 0.18, 1)';
      var DUR = '450ms';
      function setClosed(inner){
        inner.style.transition = 'none';
        inner.style.transform = 'translateX(100%)';
        // Force browser to commit the closed state before re-enabling transition
        // eslint-disable-next-line no-unused-expressions
        inner.offsetWidth;
      }
      function setOpen(inner){
        inner.style.transition = 'transform ' + DUR + ' ' + EASE;
        inner.style.transform = 'translateX(0)';
      }
      function applyDrawerState(panel){
        var inner = panel.querySelector('.ss-pf__inc-panel');
        if (!inner) return;
        if (panel.classList.contains('is-open')) {
          // If we haven't yet committed a closed state, do so first
          if (inner.style.transform !== 'translateX(100%)') {
            setClosed(inner);
          }
          // Schedule open on next tick so the closed state is painted first
          setTimeout(function(){ setOpen(inner); }, 0);
        } else {
          // Closing — animate from open to closed
          inner.style.transition = 'transform ' + DUR + ' ' + EASE;
          inner.style.transform = 'translateX(100%)';
        }
      }
      // Initialize every existing panel to closed state (no animation on first paint)
      document.querySelectorAll('.ss-pf__inc').forEach(function(p){
        var inner = p.querySelector('.ss-pf__inc-panel');
        if (inner) {
          inner.style.transition = 'none';
          inner.style.transform = 'translateX(100%)';
        }
      });
      var watcher = new MutationObserver(function(muts){
        muts.forEach(function(m){
          if (m.attributeName !== 'class') return;
          var t = m.target;
          if (t.classList && t.classList.contains('ss-pf__inc')) applyDrawerState(t);
        });
      });
      document.querySelectorAll('.ss-pf__inc').forEach(function(p){
        watcher.observe(p, { attributes: true, attributeFilter: ['class'] });
      });
      new MutationObserver(function(muts){
        muts.forEach(function(m){
          m.addedNodes && m.addedNodes.forEach(function(n){
            if (n.nodeType === 1 && n.classList && n.classList.contains('ss-pf__inc')) {
              var inner = n.querySelector('.ss-pf__inc-panel');
              if (inner) {
                inner.style.transition = 'none';
                inner.style.transform = 'translateX(100%)';
              }
              watcher.observe(n, { attributes: true, attributeFilter: ['class'] });
            }
          });
        });
      }).observe(document.body, { childList: true });
    }

    // Whole-card link: inject a real stretched <a> overlay per card so the
    // entire card is natively clickable → the product page. Replaces the old
    // JS `location.href` click handler, which the rail's drag-suppress could
    // swallow on any click that drifted past the (low) drag threshold — that
    // intermittency read as "the card isn't clickable". The overlay points at
    // the card's own "Send this" product URL. "What's Inside?" and "Send this"
    // sit above it (z-index in ss-comfort-boxes.css) and keep their behaviour.
    section.querySelectorAll('.ss-pf__card').forEach(function(card){
      if (card.dataset.polaroidWired) return;
      card.dataset.polaroidWired = '1';
      var cta = card.querySelector('.ss-pf__btn');
      if (!cta || !cta.getAttribute('href')) return;
      if (card.querySelector('.ss-pf__card-link')) return;
      var a = document.createElement('a');
      a.className = 'ss-pf__card-link';
      a.href = cta.getAttribute('href'); // keeps the localized product URL
      a.draggable = false; // stop mobile long-press from grabbing this full-card
                           // anchor and painting a white link-drag ghost over the card
      var name = card.querySelector('.ss-pf__cname');
      a.setAttribute('aria-label', name ? ('View the ' + name.textContent.trim() + ' gift box') : 'View this gift box');
      a.setAttribute('tabindex', '-1'); // avoid a duplicate tab stop; Send this + What's Inside stay focusable
      card.appendChild(a);
    });

    // "Standalone card" restyle (2026-07-10): inject the two trust badges
    // (shipping / Gift note included) and an "AUD" price suffix. CSS reorders
    // the pill to the top and styles all of this. Idempotent; AUD is skipped on
    // the UK market (£) so "£65 AUD" never renders.
    // FREE-SHIPPING GATE (2026-07-10): free shipping only applies at/above the
    // Pricing-v2 threshold — AU $119 / UK £67. Below it a
    // $9.95 flat rate applies, so "Free AU shipping" would be a false claim on
    // the $99 boxes. We read the rendered price (hardcoded per-box in index.json
    // but market-wrapped, so it shows $ for AU / £ for UK) to get BOTH the amount
    // and the market, then show "Free AU shipping" only when it qualifies and a
    // truthful "Ships AU-wide" otherwise. Gift-note badge is universally true.
    section.querySelectorAll('.ss-pf__card').forEach(function(card){
      var content = card.querySelector('.ss-pf__content');
      if (!content) return;
      var priceEl = content.querySelector('.ss-pf__price');
      var priceTxt = priceEl ? priceEl.textContent : '';
      var isGBP = priceTxt.indexOf('£') !== -1;
      var amount = parseFloat(priceTxt.replace(/[^0-9.]/g, '')) || 0;
      // 2026-09-13: every gift box ships free (all boxes clear the rate minimum),
      // so the gate is retired and the badge is unconditional.
      var freeShip = true;
      if (!content.querySelector('.ss-pf__trust-row')) {
        var footer = content.querySelector('.ss-pf__footer');
        if (footer) {
          var shipBadge = freeShip
            ? '<span class="ss-pf__trust"><i aria-hidden="true">✈</i>Free AU delivery</span>'
            : '<span class="ss-pf__trust"><i aria-hidden="true">✈</i>Ships AU-wide</span>';
          var badges = document.createElement('div');
          badges.className = 'ss-pf__trust-row';
          badges.innerHTML =
            shipBadge +
            '<span class="ss-pf__trust"><i aria-hidden="true">✉</i>Gift note included</span>';
          content.insertBefore(badges, footer);
        }
      }
      // Mobile photo badge (2026-07-23): on mobile the two trust pills are
      // replaced by ONE compact badge overlaid bottom-left on the photo (CSS
      // hides .ss-pf__trust-row ≤820px and shows this instead; desktop keeps
      // the pills and never shows the badge). Same free-ship gate as above:
      // "Free AU shipping" only when truthful, else "Gift note included".
      var photo = card.querySelector('.ss-pf__photo');
      if (photo && !photo.querySelector('.ss-pf__photo-badge')) {
        var pb = document.createElement('span');
        pb.className = 'ss-pf__photo-badge';
        pb.textContent = freeShip ? 'Free AU delivery' : 'Gift note included';
        photo.appendChild(pb);
      }
      var boxName = content.querySelector('.ss-pf__cname');
      var picturedWine = boxName && /^(For Her|Hug Away From Home|New Beginning)$/.test(boxName.textContent.trim());
      if (photo && picturedWine && !photo.querySelector('.ss-pf__wine-badge')) {
        var wineBadge = document.createElement('span');
        wineBadge.className = 'ss-pf__wine-badge';
        wineBadge.textContent = 'Piccolo add-on';
        photo.appendChild(wineBadge);
      }
      content.querySelectorAll('.ss-pf__trust').forEach(function(badge){
        if (badge.textContent.indexOf('Card included') !== -1) {
          badge.lastChild.textContent = 'Gift note included';
        }
      });
      var stars = content.querySelector('.ss-pf__stars');
      var reviewCount = stars && stars.querySelector('.ss-pf__stars-count');
      if (stars && reviewCount && !reviewCount.dataset.ratingDone) {
        var ratingMatch = (stars.getAttribute('aria-label') || '').match(/Rated\s+([\d.]+)\s+out of 5/i);
        if (ratingMatch) {
          reviewCount.textContent = ratingMatch[1] + ' · ' + reviewCount.textContent.trim();
          reviewCount.dataset.ratingDone = '1';
        }
      }
      var price = content.querySelector('.ss-pf__price');
      if (price && !price.dataset.audDone) {
        price.dataset.audDone = '1';
        if (price.textContent.indexOf('£') === -1) { // skip UK £ markets
          var cur = document.createElement('span');
          cur.className = 'ss-pf__price-cur';
          cur.textContent = ' AUD';
          price.appendChild(cur);
        }
      }
    });

    /* Mobile long-press fix: on touch devices the stretched native <a> overlay
       can still become Android Chrome's long-press/link-preview target and paint
       a pale ghost over the card, even with touch-callout/drag disabled in CSS.
       CSS removes that overlay from touch hit-testing; this guarded tap handler
       preserves normal card navigation without giving long-press a native link
       target to grab. */
    if (!section.dataset.touchCardTapWired &&
        window.matchMedia &&
        window.matchMedia('(max-width: 820px), (hover: none) and (pointer: coarse)').matches) {
      section.dataset.touchCardTapWired = '1';
      var tapState = null;
      function isCardControl(el){
        return !!(el && el.closest('button, [data-inc-open], [data-inc-close], .ss-pf__btn, .ss-pf__inc, .ss-pf__tab, .ss-pf__chapter'));
      }
      section.addEventListener('pointerdown', function(e){
        if (e.pointerType !== 'touch') return;
        var card = e.target.closest('.ss-pf__card');
        if (!card || isCardControl(e.target)) { tapState = null; return; }
        tapState = {
          card: card,
          x: e.clientX,
          y: e.clientY,
          moved: false,
          longPress: false,
          timer: setTimeout(function(){ if (tapState) tapState.longPress = true; }, 420)
        };
      }, { passive: true });
      section.addEventListener('pointermove', function(e){
        if (!tapState || e.pointerType !== 'touch') return;
        if (Math.abs(e.clientX - tapState.x) > 8 || Math.abs(e.clientY - tapState.y) > 8) tapState.moved = true;
      }, { passive: true });
      section.addEventListener('pointercancel', function(){
        if (tapState && tapState.timer) clearTimeout(tapState.timer);
        tapState = null;
      }, { passive: true });
      section.addEventListener('pointerup', function(){
        if (tapState && tapState.timer) clearTimeout(tapState.timer);
      }, { passive: true });
      section.addEventListener('click', function(e){
        var state = tapState;
        tapState = null;
        if (!state || state.moved || state.longPress || isCardControl(e.target)) return;
        var card = e.target.closest('.ss-pf__card');
        if (!card || card !== state.card) return;
        var link = card.querySelector('.ss-pf__card-link');
        if (!link || !link.href) return;
        e.preventDefault();
        window.location.href = link.href;
      }, true);
    }

    // Wrap rail + add scroll indicator (counter + progress bar) and arrow buttons.
    var rail = section.querySelector('.ss-pf__rail');
    // Wire damped + lightly-inertial wheel physics (desktop only, no-op on
    // mobile). See assets/ss-horizontal-scroll.js for tuning constants.
    if (rail && window.ssHorizontalScroll) {
      window.ssHorizontalScroll.wire(rail);
    }
    if (rail && !rail.dataset.indicatorWired) {
      rail.dataset.indicatorWired = '1';

      // Wrap rail in a positioned container
      var wrap = document.createElement('div');
      wrap.className = 'ss-pf__row-wrap';
      wrap.dataset.atStart = 'true';
      wrap.dataset.atEnd = 'false';
      rail.parentNode.insertBefore(wrap, rail);
      wrap.appendChild(rail);

      // Create prev/next scroll arrows
      function mkArrow(dir){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ss-pf__row-arrow ss-pf__row-arrow--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Scroll left' : 'Scroll right');
        b.innerHTML = dir === 'prev'
          ? '<svg viewBox="0 0 24 24"><polyline points="15 6 9 12 15 18"/></svg>'
          : '<svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"/></svg>';
        return b;
      }
      var prev = mkArrow('prev');
      var next = mkArrow('next');
      wrap.appendChild(prev);
      wrap.appendChild(next);

      function step(){
        return Math.round(rail.clientWidth * 0.6);
      }
      prev.addEventListener('click', function(e){
        e.stopPropagation();
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function(e){
        e.stopPropagation();
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });

      // Swipe-more indicator — floating chevron pill on the right edge,
      // gently animating to cue "there's more this way". Hidden via CSS
      // when [data-at-end="true"] is set on the wrap.
      var hint = document.createElement('div');
      hint.className = 'ss-pf__swipe-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>';
      wrap.appendChild(hint);

      // Build meta strip: "Box 01 / 07" counter + progress bar + hint
      var meta = document.createElement('div');
      meta.className = 'ss-pf__row-meta';
      meta.innerHTML =
        '<div class="ss-pf__row-counter">' +
          '<span class="num">01</span>' +
          '<span class="sep">/</span>' +
          '<span class="total">07</span>' +
        '</div>' +
        '<div class="ss-pf__row-progress"><div class="ss-pf__row-progress-fill"></div></div>' +
        '<div class="ss-pf__row-hint">Slide for more</div>';
      wrap.parentNode.insertBefore(meta, wrap.nextSibling);

      var counterNum = meta.querySelector('.ss-pf__row-counter .num');
      var counterTotal = meta.querySelector('.ss-pf__row-counter .total');
      var progressFill = meta.querySelector('.ss-pf__row-progress-fill');

      function updateIndicator(){
        var panels = rail.querySelectorAll('.ss-pf__panel');
        var total = panels.length;
        counterTotal.textContent = total < 10 ? '0' + total : String(total);

        var maxScroll = rail.scrollWidth - rail.clientWidth;
        var pct = maxScroll > 0 ? rail.scrollLeft / maxScroll : 0;
        wrap.dataset.atStart = (rail.scrollLeft <= 4) ? 'true' : 'false';
        wrap.dataset.atEnd = (rail.scrollLeft >= maxScroll - 4) ? 'true' : 'false';

        // Progress fill: simple scroll fraction. Min 14% (1/7) so there's
        // always some visible fill at the start.
        var fillPct = Math.max(14, pct * 100);
        progressFill.style.width = fillPct + '%';

        // Active card = whichever is closest to the left edge of viewport
        var railLeft = rail.getBoundingClientRect().left;
        var activeIdx = 0;
        for (var i = 0; i < panels.length; i++) {
          if (panels[i].getBoundingClientRect().left >= railLeft - 8) { activeIdx = i; break; }
          activeIdx = i;
        }
        counterNum.textContent = (activeIdx + 1) < 10 ? '0' + (activeIdx + 1) : String(activeIdx + 1);
      }
      // rAF-throttle so getBoundingClientRect() reads in updateIndicator()
      // don't layout-thrash on every scroll event — was the main source of
      // visible jank during left/right swipes on the polaroid rail.
      var rafPending = false;
      var scrollIdleTimer = null;
      function onScroll(){
        // Mark scroll-in-flight so card hover transforms don't fire mid-scroll.
        if (!rail.classList.contains('is-scrolling')) {
          rail.classList.add('is-scrolling');
        }
        clearTimeout(scrollIdleTimer);
        scrollIdleTimer = setTimeout(function(){
          rail.classList.remove('is-scrolling');
        }, 140);
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(function(){
          rafPending = false;
          updateIndicator();
        });
      }
      rail.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      // DESKTOP CLICK-AND-DRAG SCROLL
      // Native trackpad already scrolls horizontally — leave that alone.
      // But mouse-wheel users can't (without shift+wheel) and the rail
      // is a non-obvious affordance anyway. Adding pointer-driven drag-
      // scroll for mouse users only. Pointer events let us filter by
      // pointerType, so touch (mobile/tablet) is untouched.
      (function wireDragScroll(){
        if (!window.matchMedia || !window.matchMedia('(min-width: 769px)').matches) return;
        var dragging = false;
        var startX = 0;
        var startScroll = 0;
        var moved = 0;
        var DRAG_THRESHOLD_PX = 12; // smaller = clicks more likely (mis)read as drags and suppressed
        var activePointerId = null;

        rail.addEventListener('pointerdown', function(e){
          // Mouse only — skip touch and pen (touch already scrolls natively)
          if (e.pointerType !== 'mouse') return;
          // Reset the drag distance at the START of EVERY pointer sequence, before
          // the anchor/button skip below. Critical: clicks on the card-link overlay
          // (an <a>) take the early-return path and never run pointerdown's drag
          // setup, so without this reset a leftover `moved` value from a PREVIOUS
          // rail drag stayed stale and the click handler (moved > THRESHOLD) ate the
          // FIRST card click — cards felt dead until a second click. Now every
          // press starts clean, so a card-image click always navigates first time.
          moved = 0;
          // Skip drag-init on ANY interactive child OR any anchor — including the
          // whole-card link overlay (.ss-pf__card-link). Card clicks are the primary
          // action, so they must always navigate; rail still scrolls via
          // trackpad/wheel/arrows and the card gaps.
          if (e.target.closest('button, [data-inc-open], [data-inc-close], a')) return;
          dragging = true;
          startX = e.clientX;
          startScroll = rail.scrollLeft;
          activePointerId = e.pointerId;
          rail.classList.add('is-grabbing');
          // Capture so we keep receiving move events even if the cursor
          // leaves the rail (e.g. user drags up-and-out).
          try { rail.setPointerCapture(e.pointerId); } catch (_){}
        });

        rail.addEventListener('pointermove', function(e){
          if (!dragging || e.pointerId !== activePointerId) return;
          var dx = e.clientX - startX;
          moved = Math.max(moved, Math.abs(dx));
          // 1:1 with cursor motion — no acceleration multiplier, feels tactile.
          rail.scrollLeft = startScroll - dx;
          // Stop the browser from selecting text mid-drag
          e.preventDefault();
        });

        function endDrag(e){
          if (!dragging) return;
          dragging = false;
          rail.classList.remove('is-grabbing');
          try { rail.releasePointerCapture(activePointerId); } catch (_){}
          activePointerId = null;
        }
        rail.addEventListener('pointerup', endDrag);
        rail.addEventListener('pointercancel', endDrag);
        rail.addEventListener('pointerleave', endDrag);

        // Suppress the card click-through navigation if the user actually
        // dragged. Capture phase so we intercept before the bubble-phase
        // handler on .ss-pf__card fires window.location.href = link.href.
        rail.addEventListener('click', function(e){
          if (moved > DRAG_THRESHOLD_PX) {
            e.stopPropagation();
            e.preventDefault();
            // Reset so the NEXT genuine click works.
            moved = 0;
          }
        }, true);
      })();
      updateIndicator();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyPolaroid);
  else applyPolaroid();
})();

/* Re-parent the "View all 7 boxes" pill out of the horizontal scroll rail.
   Bug in templates/index.json: an unbalanced </div> inside one of the panel
   asides lets the .ss-pf__viewall <div> close OUTSIDE its intended wrapper —
   it ends up as the 8th flex child of .ss-pf__rail, hidden off-screen to the
   right of the 7 swipeable panels. Move it next to .ss-pf__rail at runtime
   so it sits in normal flow between the rail and the dot pagination. */
(function(){
  function lift(){
    var rail = document.querySelector('.ss-pf__rail');
    var viewall = document.querySelector('.ss-pf__viewall');
    if (!rail || !viewall) return;
    if (viewall.parentNode !== rail) return; // already lifted
    rail.parentNode.insertBefore(viewall, rail.nextSibling);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lift);
  else lift();
})();

(function(){
var _pfC=0,_pfT=(window._pfTotal||document.querySelectorAll('.ss-pf__tab').length||6),_pfX=0,_pfY=0;
// Inject side-arrow controls into each panel
function _injArrows(){
  var prevSvg='<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>';
  var nextSvg='<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>';
  document.querySelectorAll('.ss-pf__panel').forEach(function(p){
    if(p.querySelector('.ss-pf__nav'))return;
    var prev=document.createElement('button');
    prev.className='ss-pf__nav ss-pf__nav--prev';
    prev.setAttribute('aria-label','Previous box');
    prev.innerHTML=prevSvg;
    prev.onclick=function(e){e.stopPropagation();var n=_pfC-1;if(n<0)n=_pfT-1;pfSel(n);};
    var next=document.createElement('button');
    next.className='ss-pf__nav ss-pf__nav--next';
    next.setAttribute('aria-label','Next box');
    next.innerHTML=nextSvg;
    next.onclick=function(e){e.stopPropagation();var n=_pfC+1;if(n>=_pfT)n=0;pfSel(n);};
    p.appendChild(prev);p.appendChild(next);
  });
}
if(document.readyState!=='loading'){_injArrows();}else{document.addEventListener('DOMContentLoaded',_injArrows);}
function pfSel(idx){
  _pfC=idx;
  document.querySelectorAll('.ss-pf__tab').forEach(function(el,i){el.classList.toggle('ss-pf-active',i===idx);el.setAttribute('aria-selected',i===idx?'true':'false');});
  document.querySelectorAll('.ss-pf__panel').forEach(function(el,i){el.classList.toggle('ss-pf-active',i===idx);});
  var tabs=document.querySelectorAll('.ss-pf__tab');
  if(tabs[idx]){tabs[idx].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});}
}
window.pfSel=pfSel;
document.addEventListener('touchstart',function(e){
  if(e.target.closest('.ss-pf__panel.ss-pf-active')){_pfX=e.touches[0].clientX;_pfY=e.touches[0].clientY;}
},{passive:true});
document.addEventListener('touchend',function(e){
  if(!e.target.closest('.ss-pf__panel'))return;
  var dx=e.changedTouches[0].clientX-_pfX,dy=e.changedTouches[0].clientY-_pfY;
  if(Math.abs(dx)<30||Math.abs(dx)<Math.abs(dy)*1.2)return;
  if(dx<0&&_pfC<_pfT-1){_pfC++;pfSel(_pfC);}
  else if(dx>0&&_pfC>0){_pfC--;pfSel(_pfC);}
},{passive:true});
})();

/* ── MOBILE: keep pill + dot pagination in sync with carousel swipes (≤768px) ── */
(function(){
  if (window.matchMedia && !window.matchMedia('(max-width: 820px), (hover: none) and (pointer: coarse)').matches) return;
  function init(){
    var rail = document.getElementById('ss-pf-rail');
    var tabs = document.querySelectorAll('#ss-pf-tabs .ss-pf__tab');
    var dotsBox = document.getElementById('ss-pf-dots');
    if (!rail) return;
    var panels = rail.querySelectorAll('.ss-pf__panel');
    if (!panels.length) return;
    /* Build dots */
    if (dotsBox) {
      dotsBox.innerHTML = '';
      for (var i = 0; i < panels.length; i++) {
        var d = document.createElement('span');
        d.className = 'ss-pf__dot' + (i === 0 ? ' is-active' : '');
        dotsBox.appendChild(d);
      }
    }
    var dots = dotsBox ? dotsBox.querySelectorAll('.ss-pf__dot') : [];
    function setActive(i){
      for (var k = 0; k < tabs.length; k++) tabs[k].classList.toggle('ss-pf-active', k === i);
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === i);
      /* Auto-scroll active pill into view */
      var t = tabs[i];
      if (t) {
        try { t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); } catch (e) {}
      }
    }
    /* Tab click → snap rail to that card */
    for (var i = 0; i < tabs.length; i++) {
      (function(i){
        tabs[i].addEventListener('click', function(e){
          e.preventDefault();
          if (panels[i]) {
            try { panels[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' }); }
            catch (e2) { rail.scrollLeft = panels[i].offsetLeft; }
          }
        }, true);
      })(i);
    }
    /* Mobile snap is now driven by native CSS `scroll-snap-type: x mandatory`
       + `scroll-snap-stop: always` on the panels (see ss-comfort-boxes.css
       mobile correction block). The browser handles finger tracking and the
       inertia-end snap natively — much smoother than the JS-debounced
       "snap when scroll quiets down" we used to do.

       JS only stays involved for one edge case: a programmatic scroll-jump
       (anchor link, history restore, tab click) can land between snap points
       on some Android Chrome builds. `scrollend` fires after that motion
       stops and we nudge to the nearest panel just in case.

       The previous touchend-advance, debounced-scroll snap, and pageshow /
       visibilitychange queueSnap() volleys all fought the browser's native
       snap — fingerprint was visible scroll-then-jump motion. Removed. */
    function panelDistance(panel, targetX){
      return panel.getBoundingClientRect().left - targetX;
    }
    function nearestPanel(){
      var railBox = rail.getBoundingClientRect();
      var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      var targetX = railBox.left + pad;
      var best = panels[0];
      var bestDist = Infinity;
      for (var i = 0; i < panels.length; i++) {
        var dist = Math.abs(panelDistance(panels[i], targetX));
        if (dist < bestDist) {
          best = panels[i];
          bestDist = dist;
        }
      }
      return best;
    }
    function nudgeIfOffSnap(){
      var panel = nearestPanel();
      if (!panel) return;
      var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      var targetX = rail.getBoundingClientRect().left + pad;
      var delta = panelDistance(panel, targetX);
      /* Only nudge if we're far enough off-snap to be visibly wrong.
         <12px → leave the browser's snap alone. */
      if (Math.abs(delta) < 12) return;
      try { rail.scrollBy({ left: delta, behavior: 'smooth' }); }
      catch (e) { rail.scrollLeft += delta; }
    }
    if ('onscrollend' in window) {
      rail.addEventListener('scrollend', nudgeIfOffSnap, { passive: true });
    }
    /* Watch carousel scroll position to update active state */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting && e.intersectionRatio > 0.55) {
            var idx = Array.prototype.indexOf.call(panels, e.target);
            if (idx >= 0) setActive(idx);
          }
        });
      }, { root: rail, threshold: [0.55, 0.75, 1] });
      for (var i = 0; i < panels.length; i++) io.observe(panels[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* What's-included slide-in panel — open/close. Event delegation so it
   works regardless of when buttons mount (e.g. if Shopify re-renders the
   section, or if a new panel is added). */
(function(){
  /* Re-parent the panel to <body> the first time it opens. The panel lives
     inside .ss-pf__rail (a horizontal scroller with -webkit-overflow-scrolling:
     touch) which on iOS Safari creates a containing block for position:fixed.
     That's what caused the panel to render shorter than the viewport and
     leak the page's sitewide footer trust strip in underneath the products. */
  function liftToBody(panel){
    if (panel && panel.parentNode !== document.body) {
      document.body.appendChild(panel);
    }
  }
  /* Inject a small product-name caption under each tile (from the img alt
     populated by Liquid `_p.title`). Idempotent. */
  function injectCaptions(panel){
    var tiles = panel.querySelectorAll('.ss-pf__inc-item-tile');
    for (var i = 0; i < tiles.length; i++) {
      var tile = tiles[i];
      var item = tile.parentNode;
      if (!item || item.querySelector('.ss-pf__inc-item-name')) continue;
      var img = tile.querySelector('img');
      var fallbackSpan = tile.querySelector('span');
      var name = (img && img.alt) ? img.alt
               : (fallbackSpan ? fallbackSpan.textContent : '');
      if (!name) continue;
      var label = document.createElement('div');
      var isCustom = item.getAttribute('data-custom') === '1';
      label.className = 'ss-pf__inc-item-name' + (isCustom ? ' is-custom' : '');
      label.textContent = isCustom ? name + ' (Customisable)' : name;
      item.appendChild(label);
    }
  }
  /* Restyle each .ss-pf__inc-close from a 36px X icon into a "← Back" pill.
     The template (index.json) ships with just an X svg — way too small to
     find on mobile, and "X" without a label reads as "delete/dismiss"
     rather than "navigate back." We rewrite the inner DOM once at boot
     to a chevron-left + "Back" text label. CSS handles the pill shape
     and per-viewport visibility (chevron-only on desktop, full pill on
     mobile). Idempotent via data-back-enhanced. */
  function enhanceCloseButtons(root){
    var btns = (root || document).querySelectorAll('.ss-pf__inc-close');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.dataset.backEnhanced === '1') continue;
      btn.dataset.backEnhanced = '1';
      btn.innerHTML = '<svg class="ss-pf__inc-close-ico" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="ss-pf__inc-close-label">Back</span>';
      btn.setAttribute('aria-label', 'Back to all gifts');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ enhanceCloseButtons(); });
  } else {
    enhanceCloseButtons();
  }

  /* Browser back-button / Android system back closes the drawer.
     On open, push a history state tagged { ssPfInc: id }. On popstate,
     if the top of the stack was ours, close any open drawer. On manual
     close, history.back() if our state is still on top — this keeps
     the back stack consistent so the user can't get into a state where
     pressing Back re-opens the drawer they just closed. */
  var historyTokenInUse = false;

  function warmDrawerTop(id){
    var panel = document.getElementById('ss-pfi-' + id);
    if (!panel) return;
    var images = panel.querySelectorAll('.ss-pf__inc-item img');
    for (var i = 0; i < images.length; i++) {
      if (i < 2) {
        images[i].fetchPriority = 'high';
        images[i].loading = 'eager';
      }
      var src = images[i].getAttribute('data-ss-drawer-src');
      if (src && !images[i].getAttribute('src')) images[i].src = src;
    }
  }


  function openDrawer(id){
    var panel = document.getElementById('ss-pfi-' + id);
    if (!panel) return;
    warmDrawerTop(id);
    liftToBody(panel);
    injectCaptions(panel);
    enhanceCloseButtons(panel);
    panel.classList.remove('is-open');
    // eslint-disable-next-line no-unused-expressions
    panel.offsetWidth;
    setTimeout(function(){
      panel.classList.add('is-open');
    }, 20);
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ss-pf-inc-open');
    /* Push a history state so the device back button closes the drawer
       instead of leaving the page entirely. */
    try {
      history.pushState({ ssPfInc: id }, '', location.href);
      historyTokenInUse = true;
    } catch (_) { /* silently degrade — close X still works */ }
  }

  function closeDrawer(panel, viaHistory){
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ss-pf-inc-open');
    if (historyTokenInUse && !viaHistory) {
      historyTokenInUse = false;
      try { history.back(); } catch (_) {}
    } else if (viaHistory) {
      historyTokenInUse = false;
    }
  }

  function closeAnyOpenDrawer(viaHistory){
    var open = document.querySelector('.ss-pf__inc.is-open');
    if (open) closeDrawer(open, viaHistory);
  }

  window.addEventListener('popstate', function(){
    /* If a drawer is open, popstate means the user pressed Back —
       close the drawer (marked viaHistory so we don't push another back). */
    if (document.querySelector('.ss-pf__inc.is-open')) {
      closeAnyOpenDrawer(true);
    }
  });

  document.addEventListener('click', function(e){
    var open = e.target.closest('[data-inc-open]');
    if (open) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer(open.getAttribute('data-inc-open'));
      return;
    }
    var close = e.target.closest('[data-inc-close]');
    if (close) {
      e.preventDefault();
      e.stopPropagation();
      var id = close.getAttribute('data-inc-close');
      var panel = document.getElementById('ss-pfi-' + id);
      if (panel) closeDrawer(panel, false);
    }
  }, true);

  ['pointerover', 'pointerdown', 'focusin'].forEach(function(eventName){
    document.addEventListener(eventName, function(e){
      var trigger = e.target.closest('[data-inc-open]');
      if (trigger) warmDrawerTop(trigger.getAttribute('data-inc-open'));
    }, { passive: true });
  });

  // Shared window-capture geometric net (ss-dismissible.js). The "Back" pill is
  // the only tap dismiss on mobile. The selector names the pill: the backdrop
  // also carries data-inc-close and a bare [data-inc-close] rect once became a
  // whole-viewport click-eater that killed the "Send this" CTA (2026-07-26).
  if (window.ssRegisterDismissible) window.ssRegisterDismissible(function () {
    return document.querySelector('.ss-pf__inc.is-open');
  }, '.ss-pf__inc-close[data-inc-close]', function (panel) {
    closeDrawer(panel, false);
  }, {
    higherOverlays: '#ssfm-modal.is-open, .ct-root[data-open="true"], .gm-root[data-open="true"]'
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    var panel = document.querySelector('.ss-pf__inc.is-open');
    if (panel) { closeDrawer(panel, false); e.stopPropagation(); }
  });
})();

/* ─────────────────────────────────────────────────────────────
   TESTIMONIAL OVERLAY
   Reads window.ssTestimonials (set by ss-built-for-testimonials.liquid)
   and injects a floating cream quote card into each .ss-pf__photo.
   Rotates the active panel's quotes every config.rotateMs.
   ───────────────────────────────────────────────────────────── */
(function(){
  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Fallback testimonials — used when window.ssTestimonials isn't set
  // from a section or inline script. Order must match the comfort_boxes
  // tab order: Hug Away From Home, New Home, Traveller, Birthday,
  // For Him, For Her, UK Treats.
  var FALLBACK_TESTIMONIALS = [];
  // Placeholder testimonials removed pre-launch (no real customers yet) to avoid
  // fabricated social proof. To re-enable, set window.ssTestimonials (7 arrays,
  // tab order) with REAL, consented quotes.

  ready(function(){
    var data = (window.ssTestimonials && window.ssTestimonials.length) ? window.ssTestimonials : FALLBACK_TESTIMONIALS;
    var cfg  = window.ssTestimonialsConfig || {};
    var ROTATE_MS = cfg.rotateMs || 6000;

    if (!data || !data.length) return;
    var panels = document.querySelectorAll('.ss-pf__panel');
    if (!panels.length) return;

    var state = []; // one per panel

    function escapeHtml(str){
      return String(str || '').replace(/[&<>"']/g, function(c){
        return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
      });
    }

    function render(i){
      var s = state[i]; if (!s) return;
      var item = s.quotes[s.idx];
      if (!item) return;
      s.wrap.classList.add('is-swapping');
      setTimeout(function(){
        s.quoteEl.textContent = '“' + item.q + '”';
        s.citeEl.innerHTML = '<strong>' + escapeHtml(item.from) + '</strong>' +
          '<span class="ss-pf__testimonial-arrow">→</span>' +
          '<span>' + escapeHtml(item.to) + '</span>';
        Array.prototype.forEach.call(s.progEl.children, function(b, bi){
          b.classList.remove('is-on');
          void b.offsetWidth; // force reflow so animation restarts
          if (bi === s.idx) b.classList.add('is-on');
        });
        s.wrap.classList.remove('is-swapping');
      }, 200);
    }

    function next(i){
      var s = state[i]; if (!s) return;
      s.idx = (s.idx + 1) % s.quotes.length;
      render(i);
    }

    function restart(i){
      var s = state[i]; if (!s) return;
      clearInterval(s.timer);
      // Only auto-rotate the active panel's quotes
      s.timer = setInterval(function(){
        var panel = panels[i];
        if (panel && panel.classList.contains('ss-pf-active')) next(i);
      }, ROTATE_MS);
    }

    panels.forEach(function(panel, i){
      var photo = panel.querySelector('.ss-pf__photo');
      var quotes = data[i] || [];
      if (!photo || !quotes.length) { state.push(null); return; }

      var wrap = document.createElement('div');
      wrap.className = 'ss-pf__testimonial';
      wrap.style.setProperty('--ss-rotate-ms', ROTATE_MS + 'ms');

      var q = document.createElement('p');
      q.className = 'ss-pf__testimonial-quote';

      var cite = document.createElement('div');
      cite.className = 'ss-pf__testimonial-cite';

      var prog = document.createElement('div');
      prog.className = 'ss-pf__testimonial-progress';

      wrap.appendChild(q);
      wrap.appendChild(cite);
      if (quotes.length > 1) wrap.appendChild(prog);

      quotes.forEach(function(_, qi){
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show testimonial ' + (qi + 1));
        b.addEventListener('click', function(e){
          e.stopPropagation();
          var s = state[i]; if (!s) return;
          s.idx = qi % s.quotes.length;
          render(i);
          restart(i);
        });
        prog.appendChild(b);
      });

      photo.appendChild(wrap);
      state.push({ idx: 0, wrap: wrap, quoteEl: q, citeEl: cite, progEl: prog, quotes: quotes, timer: null });
      render(i);
    });

    // Boot rotation
    state.forEach(function(_, i){ if (state[i]) restart(i); });

    // Hook pfSel so the progress bar restarts on tab switch
    var originalPfSel = window.pfSel;
    if (typeof originalPfSel === 'function') {
      window.pfSel = function(idx){
        originalPfSel(idx);
        if (state[idx]) { render(idx); restart(idx); }
      };
    }
  });
})();

/* ─────────────────────────────────────────────────────────────
   CRO UPLIFT — kicker + social proof + dispatch + named pips
   + scroll-lift. Pure JS+CSS injection on the existing ss-pf
   markup (templates/index.json is locked + not edited).

   Tag: ss-2026-05-21-pre-builtfor-cro is the restore point.
   ───────────────────────────────────────────────────────────── */
(function(){
  // Per-panel config. Order matches the 7 ss-pf panels.
  // chapter = short word for the named pip strip
  // kicker  = recipient-first italic line above the title
  // badge   = optional corner-pin badge inside the photo (null = none)
  var PF_META = [
    // 2026-09-11: order MUST match the panel order in templates/index.json (comfort_boxes).
    { chapter: 'Thinking', kicker: 'For the one who needs reminding they matter', badge: null },
    { chapter: 'For Her',  kicker: 'For mums, sisters, the ones who do it all',   badge: null },
    { chapter: 'Travel',   kicker: 'For the one always boarding a plane',         badge: null },
    { chapter: 'For Him',  kicker: 'For dads, brothers, mates worth it',          badge: null },
    { chapter: 'Birthday', kicker: 'For the one whose day it is',                 badge: null },
    { chapter: 'Next',     kicker: 'For the first week of the next chapter',      badge: null }
  ];

  function inject(){
    var panels = document.querySelectorAll('.ss-pf__panel');
    if (!panels.length) return;

    panels.forEach(function(panel, i){
      var card = panel.querySelector('.ss-pf__card');
      if (!card || card.dataset.croWired === '1') return;
      card.dataset.croWired = '1';

      var meta = PF_META[i] || {};
      var cname = card.querySelector('.ss-pf__cname');
      var photo = card.querySelector('.ss-pf__photo');

      // 1. Recipient kicker — italic line BELOW the title (was: above).
      //    User preference 2026-05-23: title leads, kicker supports.
      if (cname && meta.kicker && !card.querySelector('.ss-pf__kicker')) {
        var k = document.createElement('div');
        k.className = 'ss-pf__kicker';
        k.textContent = meta.kicker;
        // Insert immediately AFTER the title (cname). If cname.nextSibling
        // is null, insertBefore appends — same effect.
        cname.parentNode.insertBefore(k, cname.nextSibling);
      }

      // 2. Corner badge — top-left pin inside the photo, mirroring the
      //    existing top-right "NO. 01" pip. Cream pill, terracotta text.
      //    Only renders for cards that opted-in via meta.badge.
      if (photo && meta.badge && !card.querySelector('.ss-pf__badge')) {
        var b = document.createElement('div');
        b.className = 'ss-pf__badge';
        b.textContent = meta.badge;
        photo.appendChild(b);
      }
    });
  }

  // Named pip strip — replace the numeric counter + "Slide for more"
  function upgradePipStrip(){
    var meta = document.querySelector('.ss-pf__row-meta');
    if (!meta || meta.dataset.namedPips === '1') return;
    meta.dataset.namedPips = '1';

    var rail = document.querySelector('.ss-pf__rail');
    if (!rail) return;
    var panels = rail.querySelectorAll('.ss-pf__panel');
    if (!panels.length) return;

    // Build named chapter pips
    var pipsWrap = document.createElement('div');
    pipsWrap.className = 'ss-pf__chapters';
    var pips = [];
    panels.forEach(function(p, i){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ss-pf__chapter';  // no default 'is-on' — hover-driven now
      btn.setAttribute('data-idx', i);
      btn.setAttribute('aria-label', 'Jump to ' + ((PF_META[i] && PF_META[i].chapter) || ('Box ' + (i+1))));
      btn.innerHTML = '<span class="ss-pf__chapter-dot"></span><span class="ss-pf__chapter-label">' +
        ((PF_META[i] && PF_META[i].chapter) || ('0' + (i+1))) + '</span>';
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        try { panels[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' }); }
        catch (e2) { rail.scrollLeft = panels[i].offsetLeft; }
      });
      pipsWrap.appendChild(btn);
      pips.push(btn);
    });

    // Hide the old counter + "Slide for more" hint; insert chapters between
    // the progress bar and the hint position.
    var oldCounter = meta.querySelector('.ss-pf__row-counter');
    var oldHint = meta.querySelector('.ss-pf__row-hint');
    if (oldCounter) oldCounter.classList.add('is-hidden-by-cro');
    if (oldHint) oldHint.classList.add('is-hidden-by-cro');
    meta.appendChild(pipsWrap);

    // HOVER-DRIVEN PIP HIGHLIGHT (2026-05-23 — replaces scroll-based syncActive)
    //
    // The old scroll-based active state had two problems:
    //   1. Pills 5-7 (For Him / For Her / UK) could never be marked active
    //      because their cards live past the rail's max scrollLeft — the
    //      "leftmost visible panel" was always one of 1-4.
    //   2. Pills LOOKED like filter toggles but were actually anchors.
    //      Users assumed toggling them combined ("FOR HER + UK") would work.
    //
    // New model: each pip highlights ONLY when the user is hovering its
    // matching card. No default-active pip. Makes the card↔pip relationship
    // explicit ("this card is THIS chapter"), and crucially every pip can
    // light up because every card is hoverable — the scroll-max math is no
    // longer a constraint.
    //
    // Bidirectional: hovering a pip also highlights the pip (via :hover CSS)
    // AND scrolls/centres the matching card into view on click (existing
    // behaviour, untouched). The reverse (hover pip → highlight card) is
    // intentionally NOT wired — cards have their own hover state already
    // (lift + shadow) and stacking two hover treatments looks busy.
    panels.forEach(function(panel, i){
      var card = panel.querySelector('.ss-pf__card') || panel;
      card.addEventListener('mouseenter', function(){
        pips[i].classList.add('is-on');
      });
      card.addEventListener('mouseleave', function(){
        pips[i].classList.remove('is-on');
      });
    });
  }

  // Scroll-lift — subtle reveal as each card enters the rail viewport
  function wireScrollLift(){
    if (!('IntersectionObserver' in window)) return;
    var rail = document.querySelector('.ss-pf__rail');
    if (!rail) return;
    var cards = rail.querySelectorAll('.ss-pf__card');
    if (!cards.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) e.target.classList.add('cro-lifted');
      });
    }, { root: rail, threshold: 0.35 });
    cards.forEach(function(c){
      c.classList.add('cro-lift-prep');
      io.observe(c);
    });
  }

  function boot(){
    inject();
    upgradePipStrip();
    wireScrollLift();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    // Pip strip is built by an earlier IIFE on DOMContentLoaded — defer one tick
    setTimeout(boot, 50);
  }
})();

/* "What's Inside?" pill upgrade (2026-06-11) — inject 3 overlapping circular
   product thumbnails (sourced from THIS box's own slide-in drawer tiles, so
   they're always in sync with the drawer) + a chevron, and a free-shipping
   line under the footer price. Pure DOM enhancement: markup in index.json
   stays untouched; CSS in ss-comfort-boxes.css styles the new bits.
   Idempotent via data-thumbs-enhanced. AU market only for the shipping
   line — detected via the rendered price symbol (£ → skip). */
(function(){
  function enhance(){
    var btns = document.querySelectorAll('.ss-pf__inc-btn[data-inc-open]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.dataset.thumbsEnhanced === '1') continue;
      btn.dataset.thumbsEnhanced = '1';
      var id = btn.getAttribute('data-inc-open');
      var drawer = document.getElementById('ss-pfi-' + id);
      if (drawer) {
        var imgs = drawer.querySelectorAll('.ss-pf__inc-item-tile img');
        if (imgs.length) {
          var wrap = document.createElement('span');
          wrap.className = 'ss-pf__inc-btn-thumbs';
          wrap.setAttribute('aria-hidden', 'true');
          for (var k = 0; k < Math.min(3, imgs.length); k++) {
            var t = document.createElement('img');
            t.setAttribute('data-ss-thumb-src', (imgs[k].getAttribute('data-ss-drawer-src') || imgs[k].src).replace(/width=\d+/, 'width=96'));
            t.alt = '';
            t.loading = 'lazy';
            t.width = 26; t.height = 26;
            wrap.appendChild(t);
          }
          var count = btn.querySelector('.ss-pf__inc-btn-count');
          btn.insertBefore(wrap, count || null);
        }
      }
      if (!btn.querySelector('.ss-pf__inc-btn-chev')) {
        var chev = document.createElement('span');
        chev.className = 'ss-pf__inc-btn-chev';
        chev.setAttribute('aria-hidden', 'true');
        chev.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        btn.appendChild(chev);
      }
    }
    /* (Free-shipping line removed 2026-06-11 — boxes are below the ~$175 AU
       free-shipping threshold, so the claim was inaccurate. Pill thumbs +
       chevron above are kept.) */
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(enhance, 80); });
  } else {
    setTimeout(enhance, 80);
  }
})();

/* ss deploy-nudge-001 — re-trigger GitHub theme sync */
